export const NOTIFICATIONSHIDE = "hideNotifications";
export const COOKIE_BANNER_CLASS = "cookie-banner";
export const COOKIE_BANNER_SELECTOR = `.${COOKIE_BANNER_CLASS}`;
